import React, { memo, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import NumericInput from 'react-numeric-input';

import { makeStyles } from '@mui/styles';

import Box from '@mui/material/Box';

const useStyles = makeStyles(theme => ({
    root: {
        '&.error': {
            borderBottomColor: theme.palette.error.main,
            borderBottomStyle: 'solid',
        },
    },
    value: {
        width: 70,
        paddingLeft: theme.spacing(1),
        flex: 1,
        fontSize: '15px !important',

        borderStyle: 'none',
        borderRadius: 4,
    },
    lvalue: {
        width: 70,
        flex: 1,
        fontSize: '15px !important',
        paddingRight: 10,
        textAlign: 'right',

        borderStyle: 'none',
        borderRadius: 4,
    },
}));

// PCR widget - Bro's producer/consumer ratio floating-point variable has range -1:1 and only makes sense when specified as a range
// So in the rest of the system the "value" of PCR is string, something like "-0.3:0.3"
function PCRWidget ({ value, onChange, style }) {
    const classes = useStyles();
    const [lValue, setLValue] = useState(0);
    const [rValue, setRValue] = useState(0);
    const [valid, setValid] = useState(false);

    const handleLValueChanged = (f, s) => {
        // reduce diff noise
        s = s === '0.0' ? '0' : s;
        onChange({ target: { value: `${s}:${rValue}` } });
    };

    const handleRValueChanged = (f, s) => {
        // reduce diff noise
        s = s === '0.0' ? '0' : s;
        onChange({ target: { value: `${lValue}:${s}` } });
    };

    useEffect(() => {
        let valid = true;
        let vals = (value || '-1:1').split(':');
        if (vals.length !== 2) {
            valid = false;
            vals = ['0', '0'];
        }
        const l = parseFloat(vals[0].trim());
        if (isNaN(l)) valid = false;
        setLValue(isNaN(l) ? 0 : l);
        const r = parseFloat(vals[1].trim());
        if (isNaN(r)) valid = false;
        setRValue(isNaN(r) ? 0 : r);
        valid = valid && l <= r; // not sure about equals here
        setValid(valid);
    }, [value]);

    return (
        <Box component="span" className={clsx(classes.root, { error: !valid })} style={style}>
            <NumericInput
                className={classes.lvalue}
                style={{ textAlign: 'right' }}
                step={0.1}
                precision={5}
                value={lValue}
                min={-1}
                max={1}
                onChange={handleLValueChanged}/>
            <span style={{ paddingLeft: 2, paddingRight: 2 }}> &nbsp;:&nbsp; </span>
            <NumericInput
                className={classes.value}
                step={0.1}
                precision={5}
                value={rValue}
                min={-1}
                max={1}
                onChange={handleRValueChanged}/>
        </Box>
    );
}

PCRWidget.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    style: PropTypes.object
};

export default memo(PCRWidget);
